export const SEARCH_VALUE_MIN_LENGTH = 2;
